import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectState } from '../../../selectors';
import ThankYouBanner from './banner';
import BottomContent from './bottom-content';
import InformationYouNeed from './information-you-need';
import SetUpReturns from './set-up-returns';

import type { ActiveFlow } from '../../../../../types';

export type ThankYouSubComponentProps = {
  activeFlow: ActiveFlow;
  accountId?: number | string | null;
};

const ThankYou = () => {
  const {
    account: { accountId, isLoggedIn },
    avataxSignup: { accountId: signupAccountId },
    system: { activeFlow },
  } = useSelector(selectState);
  const avataxAccountId = !isLoggedIn ? signupAccountId : accountId;

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ThankYouBanner />
      <SetUpReturns activeFlow={activeFlow} accountId={avataxAccountId} />
      <InformationYouNeed activeFlow={activeFlow} />
      <BottomContent />
    </Fragment>
  );
};

export default ThankYou;
